import type { PageType } from '@/types/store';
import type { StanIcon } from '@/components/core-components/types';
import IcFunnel from '@/assets/icons/ic-funnels.svg';
import IcCourse from '@/assets/icons/ic-course.svg';
import IcDigitalDownload from '@/assets/icons/ic-digital-download.svg';
import IcMembership from '@/assets/icons/ic-membership.svg';
import IcWebinar from '@/assets/icons/ic-webinar.svg';
import IcCommunity from '@/assets/icons/ic-community.svg';
import IcMeeting from '@/assets/icons/ic-meeting.svg';
import IcLeadMagnet from '@/assets/icons/ic-lead-magnet.svg';
import IcFulfillment from '@/assets/icons/ic-fulfillment.svg';

/**
 * Map of page types to their SVG icon components.
 * Mirrors Vue's `getIcon(first_page_type)` which resolves to `/images/icons/ic-{type}.svg`.
 */
const PAGE_TYPE_ICON_MAP: Partial<Record<PageType, StanIcon>> = {
    course: IcCourse,
    'digital-download': IcDigitalDownload,
    membership: IcMembership,
    webinar: IcWebinar,
    community: IcCommunity,
    booking: IcMeeting,
    'lead-magnet': IcLeadMagnet,
    fulfillment: IcFulfillment,
};

/**
 * Get the icon component for a funnel's first page type.
 * Falls back to the generic funnel icon when the page type is unknown or null.
 * Mirrors Vue's `getIcon(first_page_type)` → `/images/icons/ic-{type}.svg`.
 */
export function getFunnelPageIcon(firstPageType: PageType | null | undefined): StanIcon {
    if (firstPageType) {
        return PAGE_TYPE_ICON_MAP[firstPageType] ?? IcFunnel;
    }
    return IcFunnel;
}
